/**
 * TikTok「商品合规」属性识别（TK-PUB-35）。
 *
 * 平台把「商品合规」与「属性」拆成两个区块：
 * - 「商品合规」：Get Category Rules 下发的认证/制造商/欧盟责任人，外加一批
 *   Get Attributes 下发的商品属性（type=PRODUCT_PROPERTY），典型是「生产批次号」
 *   （EU GPSR 强制）与「安全警告」。
 * - 「属性」：其余类目属性，其中 `is_requried=true` 的是「关键属性」，其余是「选项」。
 *
 * 这里按属性名把合规类属性挑出来，交给发品页「商品合规」区块渲染，
 * 避免它们混在「属性」区里被当成普通必填属性。
 *
 * 注意：**不要**收录「原产国/原产地」「材质/成分」等——平台把它们放在「选项」里，
 * 属于普通属性，搬走反而与平台不一致。
 */
const COMPLIANCE_ATTR_PATTERNS = [
  // 生产批次号 / 批次编号（EU GPSR）
  /批次号|批次编号|生产批号/,
  // 安全警告 / 警示 / 说明
  /安全警告|安全警示|安全提示|安全说明/,
  // 制造商（类目属性形态；由类目规则下发的制造商在合规面板另有选择器）
  /制造商/,
  // 欧盟责任人 / 欧代
  /责任人|欧代|授权代表/,
  /GPSR/i,
  /safety\s*warning/i,
  /batch\s*(number|no)/i,
  /manufacturer/i,
  /responsible\s*person/i,
];

/** 属性名（兼容 name / attributeName / attribute_name） */
export function complianceAttrName(attr) {
  if (!attr || typeof attr !== 'object') return '';
  return String(attr.name ?? attr.attributeName ?? attr.attribute_name ?? '').trim();
}

/** 是否为「商品合规」类商品属性 */
export function isComplianceProductAttr(attr) {
  const name = complianceAttrName(attr);
  if (!name) return false;
  return COMPLIANCE_ATTR_PATTERNS.some((re) => re.test(name));
}

/**
 * 拆分商品属性：合规属性单独成组，其余保持原相对顺序。
 * @returns {{ compliance: Array, attributes: Array }}
 */
export function splitComplianceProductAttrs(attrs) {
  const compliance = [];
  const attributes = [];
  (Array.isArray(attrs) ? attrs : []).forEach((attr) => {
    if (isComplianceProductAttr(attr)) compliance.push(attr);
    else attributes.push(attr);
  });
  return { compliance, attributes };
}
